import { getOrigin } from '../../../helpers/path';

const localhost = 'http://localhost:3000';
export const dev = 'https://informer-dev.kubekz.indev.expert';
const stage = 'https://informer-stage.kubekz.indev.expert';
export const prod = 'https://informer.center';

const stands: Record<string, string> = {
  localhost: dev,
  'informer-dev': dev,
  'informer-stage': stage,
  informer: prod,
};

export const getBaseUrl = () => {
  const origin = getOrigin();
  const standKey = Object.keys(stands).find((key) => origin.includes(key)) || 'localhost';
  const standValue = stands[standKey];

  return standValue;
};

export const getBaseApiUrl = () => {
  const standValue = getBaseUrl() + '/api';
  return standValue;
};

type StandType = 'localhost' | 'dev' | 'stage' | 'prod';

const standOrigins: Record<StandType, string> = {
  localhost: localhost,
  dev: dev,
  stage: stage,
  prod: prod,
};

export const isCurrentHost = (stand: StandType) => {
  const origin = getOrigin();
  const standValue = standOrigins[stand];
  return origin.includes(standValue);
};
